<template>
  <div class="customerOrder-page">
    <div class="clear">
      <h2 class="paging-title">子公司客户工单</h2>
      <button class="btn-default" @click="download">导出数据</button>
    </div>
    <ul class="tab-hd">
      <li 
        v-for="(item,index) in tabs" 
        :key="index" 
        :class="{'on':listType==item.id}"
        @click="tabClick(item.id)"
      >{{item.text}}</li>
    </ul>
    <div class="filter-form">
      <div class="form-item">
        <span class="label">工单名称：</span>
        <div class="input-item">
          <input class="input" type="text" v-model="form.Title" @keydown.enter="loadData" placeholder="输入工单名称">
        </div>
      </div>
      <div class="form-item">
        <span class="label">工单号：</span>
        <div class="input-item">
          <input class="input" type="text" v-model="form.JobNo" @keydown.enter="loadData" placeholder="输入工单号">
        </div>
      </div>
      <div class="form-item">
        <span class="label">客户名称：</span>
        <div class="input-item">
          <input class="input" type="text" v-model="form.CompanyName" @keydown.enter="loadData" placeholder="输入客户名称">
        </div>
      </div>
      <div class="form-item">
        <span class="label">来源：</span>
        <div class="input-item">
          <label class="radiobox" v-for="(item,index) in radios" :key="index">
            <input name="source" type="radio" v-model="form.JobType" :value="item.value">
            <span class="radio-text">{{item.label}}</span>
          </label>
        </div>
      </div>
      <button class="btn-filter" @click="loadData">查询</button>
    </div>
    <!-- 已完成工单 -->
    <table class="table" v-show="listType==1">
      <tr>
        <th>客户</th>
        <th>所属销售公司</th>
        <th>工单名称</th>
        <th>来源</th>
        <th>服务地址</th>
        <th>发单时间</th>
        <th>完成时间</th>
        <th>金额</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index">
        <td>{{item.CompanyName}}</td>
        <td>{{item.SaleCompanyName }}</td>
        <td>
          <div>
            <div class="order-name">{{item.Title }}</div>
            <span class="order-no">工单号：{{item.JobNo }}</span>  
          </div>
        </td>
        <td>{{item.JobTypeName}}</td>
        <td>{{item.ProvinceName}}·{{item.CityName }}</td>
        <td class="time">{{item.CreateTime}}</td>
        <td class="time">{{item.FinishTime}}</td>
        <td class="price">{{item.Amount}}</td>
      </tr>
      <tr v-if="tableData.length==0">
        <td class="no-data" colspan="8">暂无数据</td>
      </tr>
    </table>
    <!-- 全部工单 -->
    <table class="table" v-show="listType==2">
      <tr>
        <th>客户</th>
        <th>所属销售公司</th>
        <th>工单名称</th>
        <th>来源</th>
        <th>服务地址</th>
        <th>发单时间</th>
        <th>上门时间</th>
        <th>状态</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index">
        <td>{{item.CompanyName}}</td>
        <td>{{item.SaleCompanyName }}</td>
        <td>
          <div>
            <div class="order-name">{{item.Title }}</div>
            <span class="order-no">工单号：{{item.JobNo }}</span>  
          </div>
        </td>
        <td>{{item.JobTypeName}}</td>
        <td>{{item.ProvinceName}}·{{item.CityName }}</td>
        <td class="time">{{(item.CreateTime).substr(0,10)}}</td>
        <td class="time">{{item.ExecStartEndTime}}</td>
        <td>
          <div class="status status1" v-if="item.JobStatusName=='服务中'">服务中</div>
          <div class="status status2" v-if="item.JobStatusName=='匹配中'">匹配中</div>
          <div class="status" v-if="item.JobStatusName=='已完成'">已完成</div>
          <span class="btn-text">{{item.SubJobStatusName}}</span>
        </td>
      </tr>
      <tr v-if="tableData.length==0">
        <td class="no-data" colspan="8">暂无数据</td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>
<script>
import {DownExcelParentCompanyJobOrderList,GetParentCompanyJobOrderList} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  data(){
    return{
      tabs:[{
        text:'已完成工单',
        id:1
      },{
        text:'全部工单',
        id:2
      }],
      radios:[
        {
          label:'全部',
          value:0
        },
        {
          label:'自由平台',
          value:1
        },
        {
          label:'B2B专区',
          value:2
        },
      ],
      listType:1,
      pageSize:10,
      pageIndex:1,
      total:0,
      form:{
        JobNo:'',
        CompanyName:'',
        JobType:0,
        Title:'',
      },
      tableData:[],
      loading:false,
    }
  },
  computed:{
    companyId(){
      if(this.$store.state.userInfo){
        return this.$store.state.userInfo.LoginAccountId;
      }
      return '';
    },
  },
  watch:{
    companyId(value,old){
      if(value && value!=old){
        this.loadData();
      }
    },
    'form.JobType'(value){
      console.log(value);
      this.loadData();
    }
  },
  mounted(){
    var name=this.$route.query.name;
    if(name){
      this.form.CompanyName=name;
    }
    if(this.companyId){
      this.loadData();
    }
  },
  methods:{
    tabClick(id){
      this.listType=id;
      this.pageIndex=1;
      this.form={
        JobNo:'',
        CompanyName:'',
        JobType:0,
        Title:'',
      }
      this.loadData();
    },
    loadData(){
      if(this.loading)return;
      this.loading=true;
      let params={
          ListType:1,
          platform:'pcweb',
          PageIndex:this.pageIndex,
          PageSize:this.pageSize,
          ParentCompanyId:this.companyId,
          ...this.form
        };
      if(this.listType==1){
        params['ListType']=1;
      }else{
        params['ListType']=2;
      }
      GetParentCompanyJobOrderList(params).then(r=>{
        this.loading=false;
        if(r.Result==1){
          this.tableData=r.Data.List || [];
          this.total=r.Data.TotalRows;
        }
      })
    },
    pageChange(data){
      this.pageIndex=data;
      this.loadData();
    },
    download(){
      var params=`platform=pcweb&ParentCompanyId=${this.companyId}&ListType=${this.listType}&Title=${this.form.Title}&JobNo=${this.form.JobNo}&CompanyName=${this.form.CompanyName}&JobType=${this.form.JobType}`;
      DownExcelParentCompanyJobOrderList(params);
    },
  }
}
</script>
<style lang="scss">
.customerOrder-page{
  .tab-hd{
    margin-top: 30px;
    background-color: #fff;
    overflow:hidden;
    li{
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      float: left;
      &:before{
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        width:0;
        transform:translate(-50%);
        transition:all 0.3s linear;
        height: 2px;
        background-color: #f75959;
      }
      &.on{
        position: relative;
        color: #f75959;
        background-color: #f8f8f8;
        &:before{
          width:100%;
        }
      }
    }
  }
  .filter-form{
    background-color:#f8f8f8;
    padding: 25px 20px 0px;
    overflow: hidden;
    position: relative;
    padding-right: 90px;
    .form-item{
      margin-bottom: 20px;
      float: left;
      overflow: hidden;
      margin-right: 30px;
    }
    .btn-group{
      float: right;
    }
    .label{
      float: left;
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
    .input-item{
      float: left;
      min-width: 160px;
      
    }
    .input{
      width: 100%;
      border: 1px solid #e5e5e5;
      background-color: #fff;
      padding: 4px 10px;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 30px;
    }
    .radiobox{
      display: inline-block;
      margin-right: 40px;
      position: relative;
      margin-top: 3px;
      cursor: pointer;
      input{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        font-size: 100px;
      }
      .radio-text{
        display: inline-block;
        padding: 0 16px;
        font-size: 14px;
        color: #666;
        border-radius: 2px;
        height: 24px;
        line-height: 24px;
      }
      input:checked+.radio-text{
        background-color: #f75959;
        color: #fff;
      }
    }
    .btn-filter{
      position: absolute;
      right: 30px;
      top: 25px;
      width: 60px;
      height: 30px;
      text-align: center;
      background-color: #f75959;
      color: #fff;
      line-height: 30px;
      cursor: pointer;
    }
  }
  .table{
    margin-top: 30px;
    border-collapse: collapse;
    border: 1px solid #e5e5e5;
    width: 100%;
    tr{
      border: 1px solid #e5e5e5;
    }
    th{
      height: 48px;
      line-height: 48px;
      background-color: #f8f8f8;
      font-size:14px;
      color:#333;
      text-align: center;
      min-width: 80px;
      font-weight: normal;
      &:nth-child(2){
        text-align: left;
      }
    }
    td{
      padding: 5px 0;
      line-height: 24px;
      font-size:14px;
      color:#333;
      text-align: center;
      &:nth-child(2){
        text-align: left;
      }
    }
    .time{
      word-break: break-all;
    }
    .money{
      color: #f75959;
    }
    .order-no{
      color: #999;
      font-size: 12px;
    }
    .status{
      font-size: 14px;
      color: #999;
      &.status1{
        color: lightgreen
      }
      &.status2{
        color: #f75959
      }
    }
    .btn-text{
      color: #333;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top: 30px;
  }
}

</style>